document.addEventListener('turbolinks:load', function () {
  $('.upload-content-modal .scroll-container').scroll(function () {
    let canrun = true
    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 0.5) {
      const page = $(this).data('paginate-next-page')

      if (page !== '') {
        canrun = false
        spin(true)
        const searchObj = $('#upload-content-modal input:text#properties_search')
        const keyword = searchObj.val()
        $.ajax({
          type: 'GET',
          url: searchObj.data('url'),
          data: { page, keywords: keyword },
          dataType: 'script',
          success: function () {
            canrun = true
          },
          error: function (error) {
            console.log(error)
          }
        })
      }
    }
  })

  $('#property_contents_upload_form').on('keyup keypress', function (e) {
    const keyCode = e.keyCode || e.which
    if (keyCode === 13) {
      e.preventDefault()
      return false
    }
  })

  const searchInput = $('#upload-content-modal #properties_search').keyup(function (e) {
    const code = e.keyCode || e.which
    if (code == 13) {
      spin(true)
      e.preventDefault()
      triggerSearch()
    }
  })

  $('#upload-content-modal #properties_search_btn').on('click', function (event) {
    spin(true)
    triggerSearch()
  })

  function triggerSearch () {
    $('#upload-content-modal #properties_search')
    const keywords = searchInput.val()
    $.ajax({
      type: 'GET',
      url: searchInput.data('url'),
      data: { keywords, page: 1 },
      dataType: 'script',
      success: function () {
        spin(false)
      },
      error: function (error) {
        console.log(error)
      }
    })
  }
})
